// extracted by mini-css-extract-plugin
export var hidden = "_ta-0";